import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Stack, Switch, Tooltip } from "@mui/material";
import DataTableLayout from "layouts/DatatableLayout";
import { ModalAllder } from "layouts/ModalAllder";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CheckIcon from "@mui/icons-material/Check";
import Select from "react-select";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { NumberFormat } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getDataclbook } from "../../redux/handlers/manage/getDataclbook.handler";
import { createclbook, clearcreateclbook } from "../../redux/handlers/manage/createclbook.handler";
import { updateclbook, clearupdateclbook } from "../../redux/handlers/manage/updateclbook.handler";
import { updateStatusclbook, clearupdateStatusclbook } from "../../redux/handlers/manage/updateStatusclbook.handler";
import { deleteclbook, cleardeleteclbook } from "../../redux/handlers/manage/deleteclbook.handler";
import { copyclbook, clearcopyclbook } from "../../redux/handlers/manage/copyclbook.handler";
export function ClBook() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), shopId = _useState[0], setShopId = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), filterText = _useState1[0], setFilterText = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), modelText = _useState2[0], setmodelText = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), filteredItems = _useState3[0], setFilteredItems = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), rowData = _useState4[0], setRowData = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), modalsuccess = _useState5[0], setModalsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), textsuccess = _useState6[0], setTextsuccess = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalCopy = _useState7[0], setModalCopy = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState8[0], setModalDel = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalPublic = _useState9[0], setModalPublic = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 400,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalClBook = _useState10[0], setModalClBook = _useState10[1];
    var getDataclbookReducer = useAppSelector(function(state) {
        return state.getDataclbookReducer;
    });
    var optionShop = [
        {
            value: 0,
            label: "ALL"
        },
        {
            value: "",
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "RT/WT"
        },
        {
            value: 3,
            label: "MT"
        }
    ];
    useEffect(function() {
        dispatch(getDataclbook({
            typeId: parseInt(shopId),
            sreachtext: filterText
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        shopId,
        filterText
    ]);
    useEffect(function() {
        setIsLoading(getDataclbookReducer.isFetching);
        if (getDataclbookReducer.data) {
            var data = getDataclbookReducer.data.data;
            setRowData(data);
            setFilteredItems(data);
        }
    }, [
        getDataclbookReducer
    ]);
    var columns = [
        {
            name: "รหัส",
            selector: function(row) {
                return row.cl_book_code;
            },
            width: "150px",
            center: "true"
        },
        {
            name: "ชื่อเล่ม",
            selector: function(row) {
                return row.cl_book_name;
            }
        },
        {
            name: "ประเภทร้านค้า",
            selector: function(row) {
                return row.cl_book_typeshop;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return row.cl_book_typeshop == 0 && "ALL" || row.cl_book_typeshop == 1 && "RT/WT" || row.cl_book_typeshop == 3 && "MT" || "-";
            }
        },
        {
            name: "จำนวน SKU",
            center: "true",
            selector: function(row) {
                return row.cl_book_total || 0;
            }
        },
        {
            name: "ประจำวันที่",
            selector: function(row) {
                return row.cl_book_day;
            },
            center: "true",
            width: "130px",
            cell: function(row, index, column, id) {
                return row.cl_book_day != null ? moment(row.cl_book_day).format("DD/MM/YYYY") : "-";
            }
        },
        {
            name: "วันที่สร้าง",
            selector: function(row) {
                return row.cl_book_credate;
            },
            center: "true",
            width: "130px",
            cell: function(row, index, column, id) {
                return row.cl_book_credate != null ? moment(row.cl_book_credate).format("DD/MM/YYYY") : "-";
            }
        },
        {
            name: "Sync",
            selector: function(row) {
                return row.cl_book_sync;
            },
            center: "true",
            width: "120px",
            cell: function(row, index, column, id) {
                return row.cl_book_sync == 3 ? /*#__PURE__*/ _jsx(CheckIcon, {
                    style: {
                        color: "#098213ff",
                        fontSize: 30
                    }
                }) : /*#__PURE__*/ _jsxs("center", {
                    children: [
                        /*#__PURE__*/ _jsx(RestartAltIcon, {
                            style: {
                                color: "#1cc1e1ff",
                                fontSize: 30
                            }
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "fs-12",
                            style: {
                                color: "#1cc1e1ff"
                            },
                            children: [
                                row.cl_book_totalsuccess,
                                "/",
                                row.cl_book_total
                            ]
                        })
                    ]
                });
            }
        },
        {
            name: "Public",
            selector: function(row) {
                return row.cl_book_public;
            },
            center: "true",
            width: "120px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Switch, {
                    checked: row.cl_book_public == 1,
                    onClick: function() {
                        setModalPublic(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true,
                                data: {
                                    id: row.cl_book_id,
                                    name: row.cl_book_name,
                                    status: row.cl_book_public
                                }
                            });
                        });
                    }
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.cl_book_id;
            },
            center: "true",
            width: "180px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/clbook/catalog/".concat(row.cl_book_id),
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "จัดการรายการสินค้า",
                                children: /*#__PURE__*/ _jsx(MenuBookIcon, {
                                    style: {
                                        color: "#0284feff",
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "#0284fe1a",
                                        padding: 5
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalCopy(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        data: {
                                            id: row.cl_book_id,
                                            name: row.cl_book_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันคัดลอกเล่มแคตตาล็อก");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "Copy",
                                children: /*#__PURE__*/ _jsx(ContentCopyIcon, {
                                    style: {
                                        color: "#ff8400ff",
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "#ff84001a",
                                        padding: 5
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalClBook(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "editClBook",
                                        data: {
                                            id: row === null || row === void 0 ? void 0 : row.cl_book_id,
                                            day: row === null || row === void 0 ? void 0 : row.cl_book_day,
                                            name: row === null || row === void 0 ? void 0 : row.cl_book_name,
                                            status: row === null || row === void 0 ? void 0 : row.cl_book_public,
                                            typeshop: row === null || row === void 0 ? void 0 : row.cl_book_typeshop
                                        }
                                    });
                                });
                                setmodelText("แก้ไขเล่มแคตตาล็อก");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "แก้ไขรายการ",
                                children: /*#__PURE__*/ _jsx(EditIcon, {
                                    style: {
                                        color: "#797A7A",
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "#E9E9E9",
                                        padding: 5
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        data: {
                                            id: row.cl_book_id,
                                            name: row.cl_book_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบเล่มแคตตาล็อก");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "ลบรายการ",
                                children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                    style: {
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "rgb(255, 227, 227)",
                                        color: "#FF0000",
                                        padding: 5
                                    }
                                })
                            })
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการเล่มแคตตาล็อก"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "จัดการเล่มแคตตาล็อก"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 4,
                                        lg: 3,
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "col-12",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 p-0",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "ค้นหาประเภทร้านค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        as: "select",
                                                        className: "w-100 select-st-3",
                                                        placeholder: "ค้นหาประเภทร้านค้า",
                                                        options: optionShop,
                                                        defaultValue: 0,
                                                        value: optionShop.find(function(opt) {
                                                            return opt.value === shopId;
                                                        }) || "",
                                                        onChange: function(e) {
                                                            setShopId(e ? e.value : "");
                                                        },
                                                        isClearable: true
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 0,
                                        md: 2,
                                        lg: 4
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 5,
                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                            direction: "horizontal",
                                            sx: {
                                                mt: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control me-3",
                                                    placeholder: "ค้นหารายการ",
                                                    value: filterText,
                                                    onChange: function(e) {
                                                        return setFilterText(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn btn-dg ml-2 w-[250px] fs-14",
                                                    onClick: function() {
                                                        setModalClBook(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: true,
                                                                typeData: "createClBook",
                                                                data: null
                                                            });
                                                        });
                                                        setmodelText("สร้างเล่มแคตตาล็อก");
                                                    },
                                                    children: "สร้างเล่มแคตตาล็อก"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalPublic,
                setModal: setModalPublic,
                htitle: "Public",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(PublicModal, {
                    setModal: setModalPublic,
                    modal: modalPublic,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalClBook,
                setModal: setModalClBook,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ClBookModal, {
                    setModal: setModalClBook,
                    modal: modalClBook,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalCopy,
                setModal: setModalCopy,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(CopyModel, {
                    setModal: setModalCopy,
                    modal: modalCopy,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function ClBookModal(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), name = _useState[0], setName = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), day = _useState1[0], setDay = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), type = _useState2[0], setType = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), id = _useState3[0], setId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), textErr = _useState4[0], setTextErr = _useState4[1];
    var _useState5 = _sliced_to_array(useState(1), 2), shops = _useState5[0], setShops = _useState5[1];
    var createclbookReducer = useAppSelector(function(state) {
        return state.createclbookReducer;
    });
    var updateclbookReducer = useAppSelector(function(state) {
        return state.updateclbookReducer;
    });
    useEffect(function() {
        if (modal.data == null) {
            setName("");
            setDay("");
            setType(2);
            setId(0);
            setTextErr("");
            setShops(1);
        }
        if (modal.data != null) {
            var vul = modal.data;
            setName(vul.name);
            setDay(vul.day ? new Date(vul.day) : null);
            setType(vul.status);
            setId(vul.id);
            setTextErr("");
            setShops(vul === null || vul === void 0 ? void 0 : vul.typeshop);
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        setIsLoading(createclbookReducer.isFetching || updateclbookReducer.isFetching);
        if (createclbookReducer.data && !createclbookReducer.isError) {
            setTextsuccess("สร้างเล่มแคตตาล็อกสำเร็จ");
            setModalsuccess(true);
            dispatch(clearcreateclbook());
            dispatch(getDataclbook(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setType(1);
            setId(0);
            setTextErr("");
            setShops(1);
        }
        if (updateclbookReducer.data && !updateclbookReducer.isError) {
            setTextsuccess("แก้ไขเล่มแคตตาล็อกสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateclbook());
            dispatch(getDataclbook(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setType(2);
            setId(0);
            setTextErr("");
            setShops(1);
        }
    }, [
        createclbookReducer,
        updateclbookReducer
    ]);
    var onClickModel = function() {
        if (modal.typeData == "createClBook") {
            if (!name) {
                setTextErr("กรุณากรอกชื่อเล่มแคตตาล็อก");
            } else if (day == "" || day == null || day == undefined) {
                setTextErr("กรุณาเลือกประจำวันที่");
            } else {
                var data = {
                    cl_book_name: name,
                    cl_book_day: day,
                    cl_book_public: type,
                    cl_book_typeshop: shops
                };
                dispatch(createclbook(data, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        } else if (modal.typeData == "editClBook") {
            if (!name) {
                setTextErr("กรุณากรอกชื่อเล่มแคตตาล็อก");
            } else if (day == "" || day == null || day == undefined) {
                setTextErr("กรุณาเลือกประจำวันที่");
            } else {
                var data1 = {
                    cl_book_id: id,
                    cl_book_name: name,
                    cl_book_day: day,
                    cl_book_public: type,
                    cl_book_typeshop: shops
                };
                dispatch(updateclbook(data1, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        }
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อเล่มแคตตาล็อก",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(name ? "" : !name ? "is-invalid" : ""),
                                placeholder: "ชื่อเล่มแคตตาล็อก",
                                value: name,
                                onChange: function(e) {
                                    setName(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-3 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ประจำวันที่ ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(DatePicker, {
                                inputFormat: "DD/MM/YYYY",
                                dateFormat: "dd/MM/yyyy",
                                placeholderText: "ประจำวันที่",
                                selected: day,
                                onChange: function(date) {
                                    setDay(date ? date : "");
                                },
                                className: "w-100 datepicker2"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xl-12 col-md-12 my-2",
                    children: [
                        /*#__PURE__*/ _jsx(Form.Label, {
                            className: "mb-2 tc-10",
                            children: "ประเภทร้านค้า"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Form.Check, {
                                    inline: true,
                                    type: "radio",
                                    id: "catalog-shop-all",
                                    label: "ALL",
                                    checked: shops === 0,
                                    className: "form-check-st-2 tc-7 mt-0",
                                    onChange: function() {
                                        return setShops(0);
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Form.Check, {
                                    inline: true,
                                    type: "radio",
                                    id: "p-radio-1",
                                    label: "RT/WT",
                                    checked: shops == 1 ? true : false,
                                    className: "form-check-st-2 tc-7 mt-0",
                                    onChange: function() {
                                        setShops(1);
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Form.Check, {
                                    inline: true,
                                    type: "radio",
                                    id: "p-radio-2",
                                    label: "MT",
                                    checked: shops == 3 ? true : false,
                                    className: "form-check-st-2 tc-7 mt-0",
                                    onChange: function() {
                                        setShops(3);
                                    }
                                })
                            ]
                        }, "p-radio")
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12 mt-2",
                    children: /*#__PURE__*/ _jsx(Form.Label, {
                        className: "mb-2 mt-2 tc-10",
                        children: "สถานะ"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Check, {
                                inline: true,
                                type: "radio",
                                id: "p-radio-1",
                                label: "เปิดใช้งาน",
                                checked: type == 1 ? true : false,
                                className: "form-check-st-2 tc-7 mt-0",
                                onChange: function() {
                                    setType(1);
                                }
                            }),
                            /*#__PURE__*/ _jsx(Form.Check, {
                                inline: true,
                                type: "radio",
                                id: "p-radio-2",
                                label: "ปิดใช้งาน",
                                checked: type == 2 ? true : false,
                                className: "form-check-st-2 tc-7 mt-0",
                                onChange: function() {
                                    setType(2);
                                }
                            })
                        ]
                    }, "p-radio")
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "flex-end",
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-6 me-3 btn py-2 px-3 mt-4",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: false
                                        });
                                    });
                                },
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "mt-4 btn btn-dg w-400",
                                onClick: function(e) {
                                    onClickModel();
                                },
                                children: "บันทึก"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
export function PublicModal(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var _modal_data;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(1), 2), type = _useState[0], setType = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), id = _useState1[0], setId = _useState1[1];
    var updateStatusclbookReducer = useAppSelector(function(state) {
        return state.updateStatusclbookReducer;
    });
    useEffect(function() {
        if (modal.data == null) {
            setType(1);
            setId(0);
        }
        if (modal.data != null) {
            var vul = modal.data;
            setType(vul.status);
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        setIsLoading(updateStatusclbookReducer.isFetching);
        if (updateStatusclbookReducer.data && !updateStatusclbookReducer.isError) {
            setTextsuccess("แก้ไขสถานะเล่มแคตตาล็อกสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateStatusclbook());
            dispatch(getDataclbook(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setType(1);
            setId(0);
        }
    }, [
        updateStatusclbookReducer
    ]);
    var onClickModel = function() {
        var data = {
            clbookid: id,
            clbookstatus: type == 1 ? 2 : 1
        };
        dispatch(updateStatusclbook(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการเปลี่ยนสถานะข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
export function DelModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var deleteclbookReducer = useAppSelector(function(state) {
        return state.deleteclbookReducer;
    });
    useEffect(function() {
        setIsLoading(deleteclbookReducer.isFetching);
        if (deleteclbookReducer.data && !deleteclbookReducer.isError) {
            setTextsuccess("ลบสถานะเล่มแคตตาล็อกสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeleteclbook());
            dispatch(getDataclbook(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        deleteclbookReducer
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        var data = {
            clbookid: parseInt(id)
        };
        dispatch(deleteclbook(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการลบข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
export function CopyModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var copyclbookReducer = useAppSelector(function(state) {
        return state.copyclbookReducer;
    });
    useEffect(function() {
        setIsLoading(copyclbookReducer.isFetching);
        if (copyclbookReducer.data && !copyclbookReducer.isError) {
            setTextsuccess("คัดลอกแคตตาล็อกสำเร็จ กำลังเพิ่มข้อมูลสินค้า");
            setModalsuccess(true);
            dispatch(clearcopyclbook());
            dispatch(getDataclbook(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        copyclbookReducer
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        var data = {
            clbookid: parseInt(id)
        };
        dispatch(copyclbook(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการคัดลอกข้อมูลเล่มนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
